import * as Sentry from '@sentry/react'
import { isAxiosError } from 'axios'
import { isDemoEnvironment } from '~/shared/lib/environment'

const isLoginPageAxios404 = (
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
): boolean => {
  const error = hint.originalException

  if (!isAxiosError(error) || error.response?.status !== 404) {
    return false
  }

  const transaction = event.transaction ?? event.tags?.transaction

  if (transaction === '/login') {
    return true
  }

  return Boolean(event.request?.url?.includes('/login'))
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  enabled: import.meta.env.MODE !== 'development' && !isDemoEnvironment,
  environment: import.meta.env.VITE_USER_NODE_ENV,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  beforeSend(event, hint) {
    if (isLoginPageAxios404(event, hint)) {
      return null
    }

    return event
  },
})
